import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { I18NextPipe } from 'angular-i18next';

@Component({
  selector: 'app-edit-group-number',
  templateUrl: './edit-group-number.component.html',
  styleUrls: ['./edit-group-number.component.scss'],
  standalone: false
})
export class EditGroupNumberComponent implements OnInit {

  groupNumberId: number | null = null;
  isNew = false;
  pageHeading = '';

  BreadcrumbsLink = [
    { label: 'Home', url: '/' },
    { label: 'Users', url: '/users/users' },
    { label: '', url: '' }
  ];

  constructor(
    private route: ActivatedRoute,
    private i18n: I18NextPipe
  ) {}

  ngOnInit(): void {
    const idParam = this.route.snapshot.paramMap.get('groupNumberId');
    this.groupNumberId = idParam ? Number(idParam) : null;
    this.isNew = !this.groupNumberId;

    if (this.isNew) {
      this.pageHeading = this.i18n.transform('users:groupnumber_createNewGroupnumber') || 'Create New Group Number';
      this.BreadcrumbsLink[2].label = this.pageHeading;
    } else {
      const headingRaw = this.i18n.transform('users:editgroupnumber_header') || 'Edit Group Number';
      this.pageHeading = headingRaw.replace('{0}', String(this.groupNumberId));
      this.BreadcrumbsLink[2].label = headingRaw
        .replace(/<[^>]*>/g, '')
        .replace('{0}', String(this.groupNumberId));
    }
  }
}
